module.exports = __webpack_public_path__ + "img/empty.5c54a29f.png";